import React from 'react';
import { BasicDialog, Text } from 'library';
import { Grid } from '@material-ui/core';
import { useModalsContext } from 'ModalsContext';

interface IProps {
    open: boolean;
    close: () => void;
}

export default function InternalMessagingModal({ open, close }: IProps) {
    const { openJobForm } = useModalsContext();

    const dialogContent = () => {
        return (
            <Grid>
                <Text variant="body1">
                    Post a job before you start messaging providers. A job posting gives our providers context about
                    your needs and gets you talking with the right people faster.
                </Text>
            </Grid>
        );
    };

    return (
        <BasicDialog
            isOpen={open}
            onClose={close}
            children={dialogContent()}
            closeButton={true}
            dialogTitle={'Hold on!'}
            buttonText={'Post Job'}
            onSubmit={() => openJobForm('Internal messaging block')}
            buttonEnabled={true}
            webMaxWidth={'200px'}
        />
    );
}
